export const adap_retiro_mov = ({usuario, compra, metodo, billetera}) => {

    let obj = {
        tipo: compra.desde,
        idUsuario: usuario.id,
        codigoUsuario: usuario.codigo,
        fecha: compra.fecha,
        hashString: compra.hashString,
        hash: compra.hash,
        consecutivo: compra.consecutivo,
        nombre: usuario.nombre,
        valor: compra.valor,
        moneda: 'UDS',
        departamento: 'Adminstracion',
        correo: usuario.correo,
        visible: 'Visible',
        detalle: compra.detalle,
        metodo: metodo,
        billetera: billetera
    }

    return obj


}